<template>
    <v-card>
      <new-klent
      v-if="add_klent_com"
      v-on:save_klent_success="save_klent_success"
      v-on:save_klent_error="save_klent_error"
      v-on:close_klent="close_klent"
      ></new-klent>


      <v-card-text>
          <v-data-table
              :headers="headers"
              :items="bonuses"
              :search="search"
              :loading="loading"
              loading-text="Загрузка. Пожалуйста подождите"
                :footer-props="{
                    'items-per-page-options': [ 7, 20, 50, 100],
                    'items-per-page-text':'Строк на странице',
                }"
                no-data-text="Данные отсутствуют в таблице"
              class="elevation-1"
          >
              <template v-slot:top>
                  <v-toolbar flat>
                      <v-toolbar-title>Тип бонус</v-toolbar-title>
                      <v-divider
                          class="mx-4"
                          inset
                          vertical
                      ></v-divider>

                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Поиск"
                          single-line
                          hide-details
                      ></v-text-field>
                  </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="edit_bonus(item)">
                      mdi-pencil
                  </v-icon>
              </template>
              <template v-slot:no-data>
                  <v-btn color="primary"  text @click="get_bonuses">
                      Загрузить
                  </v-btn>
              </template>
          </v-data-table>



          <v-dialog
          v-model="edit_bonus_dialog"
          max-width="400"
          @click:outside="close_edit_bonus"
        >
          <v-card>
            <v-card-title class="text-h5">
              Редактирование типа бонуса
            </v-card-title>

            <v-card-text>
              <v-text-field
                  v-model="bonus.namud"
                  label="Тип бонуса"
                    disabled
              ></v-text-field>

              <v-text-field
                  v-model="bonus.sum_furush_az"
                  label="Сумма продажа с"
                  :rules="mikdorRules"
              ></v-text-field>

              <v-text-field
                  v-model="bonus.sum_furush_to"
                  label="Сумма продажа до"
                  :rules="mikdorRules"
              ></v-text-field>

              <v-text-field
                  v-model="bonus.foiz"
                  label="Бонус %"
                  :rules="mikdorRules"
              ></v-text-field>

                  <v-switch
                  v-model="bonus.holat"
                  :label="bonus.holat ==1 ? 'Активный' : 'Не активный'"
                ></v-switch>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="error darken-1"
                text
                @click="close_edit_bonus"
              >
                Отмена
              </v-btn>

              <v-btn
                color="green darken-1"
                text
                @click="change_bonus"
                :loading="loading"
                :disabled="bonus.sum_furush_az == '' || bonus.sum_furush_to == '' || bonus.foiz == '' || ( parseFloat( bonus.sum_furush_az) > parseFloat( bonus.sum_furush_to)) || ( parseFloat( bonus.foiz) > parseFloat(100))"
              >
                Изменить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <v-snackbar
          v-model="snack"
          :timeout="3000"
          :color="snackColor"
        >
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              v-bind="attrs"
              text
              @click="snack = false"
            >
              Закрыть
            </v-btn>
          </template>
        </v-snackbar>

      </v-card-text>
    </v-card>
  </template>

  <script>
  export default {

      data: () => ({

          snack: false,
          snackColor: '',
          snackText: '',

          search: '',
          loading: false,

          bonus_namud: [
          { text: 'Нет', value: 0},
          { text: 'Обычный', value: 1},
          { text: 'По каджой покупки', value: 2},
          { text: 'Месячное', value: 3}

          ],



          headers: [
              {
                  text: '№',
                  align: 'start',
                  sortable: false,
                  value: 'id_bonus_namud',
              },
              { text: 'Тип', value: 'namud' },
              { text: 'Сумма продажа с', value: 'sum_furush_az' },
              { text: 'Сумма продажа до', value: 'sum_furush_to' },
              { text: 'Бонус %', value: 'foiz' },
              { text: 'Статус', value: 'holat_nom' },
              { text: 'Действия', value: 'actions', sortable: false },
          ],

          mikdorRules:[
            v => !!v || 'Обязательное поле',
            v=> (v && /[0-9]/.test(v)) || 'Неверный формат ввода',
            v => (v && /^\d*\.?\d*$/.test(v)) || 'Неверный формат ввода',
      ],
          bonuses: [],
          bonus: {},
          edit_bonus_dialog: false,

      }),

      mounted() {
          this.get_bonuses();
      },
      methods: {

          get_bonuses() {
              this.loading = true;
              axios.get('/api/get_bonuses',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.bonuses = response.data.bonuses;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения клиентов"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });
          },

          change_bonus(){
                this.loading = true;
                axios.post('/api/change_bonus', this.bonus,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'success'
                                    this.snackText = "Тип бонуса изменен"
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                    this.close_edit_bonus();
                                    this.get_bonuses();
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Ошибка изменения типа бонуса"
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
          },



          edit_bonus(item){
              this.edit_bonus_dialog = true;
              this.bonus = item;
          },

          close_edit_bonus(){
              this.edit_bonus_dialog = false;
              this.bonus = {};
          },




      }
  }
  </script>

  <style>

  </style>






